/**
 * 総当たり（ラウンドロビン）のスケジュール生成
 */
import { TournamentMatch } from '../types/Tournament';

/**
 * 全参加者の総当たりスケジュールを生成する。
 * 円形配置法（Circle method）を用いて各ラウンドを均等に分散させる。
 * nC2 = n*(n-1)/2 試合が生成される。
 *
 * @param participantIds 参加者IDの配列
 * @returns 全試合の配列（matchIndex付き）
 * @throws 参加者が2名未満の場合
 */
export function generateRoundRobinMatches(participantIds: string[]): TournamentMatch[] {
  if (participantIds.length < 2) {
    throw new Error(`At least 2 participants required, got ${participantIds.length}`);
  }

  const n = participantIds.length;
  // 奇数の場合はダミーを追加（ダミー戦はスキップ）
  const ids = n % 2 === 0 ? [...participantIds] : [...participantIds, '__bye__'];
  const size = ids.length; // 必ず偶数
  const rounds = size - 1;
  const matchesPerRound = size / 2;

  const matches: TournamentMatch[] = [];
  let matchIndex = 0;

  // 円形配置法: ids[0]を固定し、残りをローテーション
  const rotating = ids.slice(1);

  for (let round = 0; round < rounds; round++) {
    // このラウンドの対戦ペアを生成
    const current = [ids[0], ...rotating];
    for (let i = 0; i < matchesPerRound; i++) {
      const p1 = current[i];
      const p2 = current[size - 1 - i];
      // ダミー戦はスキップ
      if (p1 === '__bye__' || p2 === '__bye__') continue;
      matches.push({
        matchIndex,
        participant1Id: p1,
        participant2Id: p2,
      });
      matchIndex++;
    }
    // rotatingを1つ右にシフト
    rotating.unshift(rotating.pop()!);
  }

  return matches;
}
